import { useTranslation } from "@opendash/i18n";
import { Form, FormItemProps } from "antd";
import { observer } from "mobx-react-lite";
import Parse, { Role, User } from "parse";
import React, { useEffect } from "react";
import { SaveTicketValues } from "../../..";
import { useFieldConfig } from "../../hooks/useFieldConfig";
import { useSaveConfigManager } from "../../hooks/useSaveConfigManager";
import { AssignmentSelect } from "./assignment/AssignmentSelect";

type Props = {
  type: "dropdown";
} & FormItemProps<SaveTicketValues>;

export const AssignmentInput = observer((props: Props) => {
  const t = useTranslation();
  const manager = useSaveConfigManager();
  const [loading, setLoading] = React.useState(true);
  const [users, setUsers] = React.useState<User[]>([]);
  const [roles, setRoles] = React.useState<Role[]>([]);
  const config = useFieldConfig("assignedTo");

  useEffect(() => {
    if (!manager) return;
    manager?.registerPreperation("assignedTo");
    const fetchUsers = async () => {
      const users = await new Parse.Query(User).find();
      setUsers(users);
    };

    const fetchRoles = async () => {
      const roles = await new Parse.Query(Role).find();
      setRoles(roles);
    };

    const fetchData = async () => {
      setLoading(true);
      await Promise.all([fetchUsers(), fetchRoles()]);
      manager?.markFieldPrepared("assignedTo");
      setLoading(false);
    };

    fetchData();
  }, [manager]);

  if ((config && config.hidden) || loading) return <></>;

  const label =
    config?.label === "-"
      ? ""
      : config?.label || t("maintenance:ticket.create.assignedTo.label");

  return (
    <Form.Item<SaveTicketValues>
      name="assignedTo"
      label={label}
      help={config?.help}
      rules={[
        {
          required: config?.required,
          message: t("maintenance:ticket.create.assignedTo.error.empty"),
        },
      ]}
      {...props}
    >
      {props.type === "dropdown" && (
        <AssignmentSelect users={users} roles={roles} />
      )}
    </Form.Item>
  );
});
